var map = {
	"./epure-layer.svg": "ae0f",
	"./folder-layer.svg": "470a",
	"./heatmap-layer.svg": "7962",
	"./line-layer.svg": "41b6",
	"./matrix-layer.svg": "f158",
	"./model-layer.svg": "46f0",
	"./node-layer.svg": "e3a0",
	"./polygon-layer.svg": "b612",
	"./style-presets.svg": "e270",
	"./stylize.svg": "59c8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6057";